<!--The content below is only a placeholder and can be replaced.-->
<adc-header name="Header"></adc-header>
<spinner class="spinner-class"></spinner>
<session-dialog></session-dialog>
<app-flightchangehistory></app-flightchangehistory>
<adc-footer name="Footer"> </adc-footer>